import React from 'react';

import LoadingSpinner from '../../../../components/shared/LoadingSpinner';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const ShareModalDrawerTextMessage = createReactClass({
  getInitialState() {
    return {
      showSpinner: false,
      buttonEnabled: false,
      buttonLabel: StringConstantsMixin.strings.MOBILE.TEXT_LINK
    };
  },
  componentDidMount() {
    // todo: There is a purely react version of this that we should pull in once yarn/NPM are part of our toolbox
    // https://github.com/patw0929/react-intl-tel-input
    // as is, we can only access this input again without wiping it by storing it in state
    const input = this.props.document.querySelector('#phone');
    const telInputOptions = {};
    if (this.props.currentUser && this.props.currentUser.location && this.props.currentUser.location.country) {
      telInputOptions.initialCountry = this.props.currentUser.location.country;
    }
    let telInput;
    // Defend against us not having a proper iso_3166_code for what we treat as a country
    try {
      telInput = window.intlTelInput(input, telInputOptions);
    } catch (err) {
      if (telInputOptions.initialCountry) {
        telInput = window.intlTelInput(input);
      }
    }
    this.setState({ input: telInput });
    // Size phone number input based on width of send button (which varies a lot by language)
    const widthContainer = this.props.jQuery('div.messaging-container').width();
    const widthButton = this.props.jQuery('button.send-sms-msg').width();
    this.props.jQuery('div.iti.iti--allow-dropdown').width(widthContainer - widthButton - 28);
  },
  sendTextMessage() {
    _gaq.push(['_trackEvent', 'Share', 'sms-send', this.props.shareObject.type]);
    const iti = this.state.input;
    this.setState({
      showSpinner: true
    });
    this.props.sendSMSMessage(iti.getNumber(), this.props.shareObject, this.props.lang, this.props.locale, this.onSendFailed);
  },
  onSendFailed() {
    this.setState({
      showSpinner: false,
      buttonLabel: StringConstantsMixin.strings.FAILED
    });
  },
  isValidNumber(e) {
    const value = e.target.value;
    const hasNumbers = value.replace(/[^0-9]/g, '').length > 0;
    // checking for commas and semicolons to prevent people from attempting to send to mulitple numbers
    const punctuationMarks = [',', ';'];
    const isSinglePhoneNumber = !punctuationMarks.some(mark => value.includes(mark));
    return hasNumbers && isSinglePhoneNumber;
  },
  onPhoneNumberChange(e) {
    const isValid = this.isValidNumber(e);
    this.setState({
      buttonEnabled: isValid
    });
  },
  render() {
    let button;
    if (this.state.showSpinner) {
      button = (
        <div className="send-sms-msg-ellipsis">
          <LoadingSpinner />
        </div>
      );
    } else {
      button = (
        <button className="send-sms-msg" disabled={!this.state.buttonEnabled} onClick={this.sendTextMessage}>
          {this.state.buttonLabel}
        </button>
      );
    }
    return (
      <div className="form-holder">
        <p>{StringConstantsMixin.strings.SHARE_MODAL.SMS_INSTRUCTIONS}</p>
        <div className="messaging-container">
          <input type="tel" id="phone" onChange={this.onPhoneNumberChange} />
          {button}
        </div>
      </div>
    );
  }
});

export { ShareModalDrawerTextMessage };
